import React, { useState } from 'react';
import './App.css';
import axios from 'axios';

import Login from './Login';
import Register from './Register';

import ProjectRoom from './components/ProjectRoom';
import Home from './components/Home';
import Profile from './components/Profile';
import MyProjects from './components/MyProjects';
import CreateProject from './components/CreateProject';
import JoinProject from './components/JoinProject';

function App() {
    const [isLoggedIn, setIsLoggedIn] = useState(!!sessionStorage.getItem('token'));

    const [user, setUser] = useState(() => {
        const savedUser = sessionStorage.getItem('user');
        if (savedUser && savedUser !== "undefined") {
            return JSON.parse(savedUser);
        }
        return null;
    });

    const [showLogin, setShowLogin] = useState(true);
    const [activePage, setActivePage] = useState('home');
    const [selectedProject, setSelectedProject] = useState(null);

    // Function to handle clicking a project in Home or MyProjects
    const handleProjectClick = (project) => {
        setSelectedProject(project);
        setActivePage('project-room');
    };

    const handleProfilePicClick = () => {
        const input = document.getElementById('profileInput');
        if (input) input.click();
    };

    const handleFileChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append('profilePic', file);

        try {
            const token = sessionStorage.getItem('token');
            const res = await axios.put('/api/auth/profile-pic', formData, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data'
                }
            });

            const updatedUser = { ...user, profile_pic: res.data.profile_pic };
            setUser(updatedUser);
            sessionStorage.setItem('user', JSON.stringify(updatedUser));
            alert("Profile picture updated!");
        } catch (err) {
            console.error(err);
            alert("Upload failed.");
        }
    };

    const handleLoginSuccess = (userData) => {
        setIsLoggedIn(true);
        setUser(userData);
        sessionStorage.setItem('user', JSON.stringify(userData));
    };

    const handleLogout = () => {
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('user');
        setIsLoggedIn(false);
        setUser(null);
        setActivePage('home'); // Reset page on logout
    };

    if (isLoggedIn && !user) {
        return <div className="App"><h1>Loading User Data...</h1></div>;
    }

    if (!isLoggedIn) {
        return (
            <div className="App">
                <h1 className="app-logo-text" style={{ fontSize: '3rem', marginBottom: '20px' }}>Connect</h1>
                {showLogin ? (
                    <Login onLoginSuccess={handleLoginSuccess} />
                ) : (
                    <Register onRegisterSuccess={() => setShowLogin(true)} />
                )}
                <button
                    className="toggle-btn"
                    onClick={() => setShowLogin(!showLogin)}
                >
                    {showLogin ? "Need an account? Register" : "Already have an account? Login"}
                </button>
            </div>
        );
    }

    return (
        <div className="dashboard-wrapper">
            <aside className="right-sidebar">
                <div className="user-profile-card">
                    <div 
                        className="avatar-placeholder" 
                        onClick={handleProfilePicClick} 
                        style={{ cursor: 'pointer', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                    >
                        {user?.profile_pic ? (
                            <img
                                src={`${user.profile_pic}`}
                                alt="Profile"
                                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                            />
                        ) : (
                            <span style={{ color: 'white', fontSize: '1.5rem', fontWeight: 'bold' }}>
                                {user?.username?.charAt(0).toUpperCase()}
                            </span>
                        )}
                    </div>

                    <input
                        type="file"
                        id="profileInput"
                        style={{ display: 'none' }}
                        accept="image/*"
                        onChange={handleFileChange}
                    />

                    <div className="user-meta">
                        <span className="user-name">{user?.username || "User"}</span>
                        <span className="user-status">● Online</span>
                    </div>
                    <button className="logout-link" onClick={handleLogout}>Logout</button>
                </div>

                <nav className="side-nav">
                    <button
                        className="nav-item create-btn-highlight"
                        onClick={() => setActivePage('create-project')}>+ Create Project</button>
                    <button
                        className={activePage === 'home' ? 'nav-item active' : 'nav-item'}
                        onClick={() => setActivePage('home')}>Home</button>
                    <button
                        className={activePage === 'my-projects' ? 'nav-item active' : 'nav-item'}
                        onClick={() => setActivePage('my-projects')}>My Projects</button>
                    <button
                        className={activePage === 'profile' ? 'nav-item active' : 'nav-item'}
                        onClick={() => setActivePage('profile')}>Profile</button>
                    <button
                        className={activePage === 'join-project' ? 'nav-item active' : 'nav-item'}
                        onClick={() => setActivePage('join-project')}>Join Project with Code</button>
                </nav>
            </aside>

            <main className="main-content">
                <header className="content-header">
                    <div className="header-left">
                        <img src="/logo.png" alt="Connect Ideas Logo" className="app-logo-image" />
                        <h1 className="app-logo-text">Connect</h1>
                    </div>
                </header>

                <section className="page-container">
                    {activePage === 'home' && <Home user={user} onProjectClick={handleProjectClick} />}
                    {activePage === 'profile' && <Profile user={user} />}
                    {activePage === 'my-projects' && <MyProjects user={user} onProjectClick={handleProjectClick} />}
                    {activePage === 'create-project' && <CreateProject user={user} />}
                    {activePage === 'join-project' && <JoinProject user={user} />}
                    
                    {/* Render ProjectRoom when active */}
                    {activePage === 'project-room' && selectedProject && (
                        <ProjectRoom project={selectedProject} user={user} />
                    )}
                </section>
            </main>
        </div>
    );
}

export default App;